import { parseMsToTime } from "./helper";

export const countDown = ({ duration, tickCallback, completeCallback }) => {
  let currentTime = duration;

  const intervalId = setInterval(() => {
    if (currentTime <= 0) {
      clearInterval(intervalId);
      completeCallback && completeCallback();
    } else {
      currentTime -= 1000;
      tickCallback({
        timer: parseMsToTime(currentTime),
        ms: currentTime
      })
    }
  }, 1000);

  return () => clearInterval(intervalId);
};
